<div class="dropdown-holder">
  <div
    class="header"
    [class.justify-center]="!showActiveInfo"
    [suiMenuTrigger]="moduleMenu"
  >
    <div class="active-module-info">
      <fa-icon [icon]="activeModule.icon"></fa-icon>
      @if (showActiveInfo) {
        <div class="active-module">
          {{ activeModule.nameKey | translate }}
        </div>
      }
    </div>
    @if (showActiveInfo) {
      <fa-icon class="dropdown-toggle" [icon]="['fas', 'bars']"></fa-icon>
    }
  </div>
  <ng-template #moduleMenu>
    <sui-menu>
      <sui-menu-header>
        {{ "module-switch.title.switch-to" | translate }}:
      </sui-menu-header>
      <sui-menu-separator></sui-menu-separator>
      @for (module of availableModules; track module) {
        <button
          sui-menu-item
          [selected]="module.active"
          (click)="switchModule(module)"
        >
          @if (module.icon) {
            <fa-icon [icon]="module.icon"></fa-icon>
          }
          <span>{{ module?.nameKey | translate }}</span>
        </button>
      }
    </sui-menu>
  </ng-template>
</div>
